import { pushToDataLayerDirectly } from '@/ui/scripts/analytics/analytics.methods';

const allUpdates = [...document.getElementsByClassName('js-all-updates-ga')];

function actionType(el) {
  return el.getAttribute('aria-expanded') === 'false' ? 'Open' : 'Close';
}

function handleLinkClick(event) {
  pushToDataLayerDirectly({
    event: 'project_page_all_updates_click',
    link_text: event.target.innerText,
    link_url: event.target.href,
    element_title: event.target
      .closest('.js-update-card-ga')
      .getElementsByClassName('js-card-title-ga')[0].innerText,
  });
}

function handleTriggerClick(title, event) {
  pushToDataLayerDirectly({
    event: 'project_page_all_updates_accordion',
    accordion_action: actionType(event.target),
    link_text: event.target.innerText,
    element_title: title.innerText,
  });
}

function init() {
  if (!allUpdates.length) {
    return;
  }

  allUpdates.forEach((accordion) => {
    const links = [...accordion.querySelectorAll('.js-update-card-ga a')];
    const title = accordion.getElementsByClassName('js-all-updates-title-ga')[0];
    const triggers = [...accordion.getElementsByClassName('js-all-updates-trigger-ga')];

    links.forEach((trigger) => trigger.addEventListener('click', handleLinkClick));

    triggers.forEach((trigger) =>
      trigger.addEventListener('click', handleTriggerClick.bind(this, title)),
    );
  });
}

export default init;
